import { Directive } from '@angular/core';

@Directive({ selector: '[emiCustomPopupContent]' })
export class CustomPopupContentDirective {}
